import { supabase } from './engine';

// ---------------------------------------------------------------------------
// Decisión "Cliente no renueva" — UN solo lector para todo el sistema.
//
// Se toma en el CRM al cerrar una tarea de renovación con ese motivo
// (CRM.jsx → handleCerrarConMotivo), que deja en `crm_historial` una fila
// accion 'cerrar' cuyo detalle empieza con MARCA_NO_RENUEVA. La leen:
//   · el CRM (no recrear la tarea; cerrar las duplicadas),
//   · Pólizas (estado 'no_renovada' al vencer),
//   · Renovaciones (contarla como "No renovada").
// Si se cambia el texto de la marca en el CRM, solo hay que cambiarlo aquí.
//
// La decisión vale SOLO para la vigencia en que se tomó: se guarda el vencimiento
// de la tarea cerrada y se compara con el de la póliza. Una póliza renovada sobre
// el mismo registro el año siguiente vuelve a tener su tarea normal.
// ---------------------------------------------------------------------------

export const MARCA_NO_RENUEVA = '[Cliente no renueva]';

const TROZO = 150;   // ids por consulta (que la URL de PostgREST no se pase de largo)

// polIds → Map(poliza_id → Set de vencimientos 'AAAA-MM-DD' donde se decidió "no renueva").
// Dos consultas por trozo, nunca una por póliza.
export async function decisionesNoRenueva(polIds) {
  const res = new Map();
  const ids = [...new Set((polIds || []).map(Number).filter(Boolean))];
  for (let i = 0; i < ids.length; i += TROZO) {
    const trozo = ids.slice(i, i + TROZO);
    const { data: cerradas } = await supabase.from('crm_gestiones')
      .select('id, poliza_id, fecha_vencimiento')
      .eq('tipo', 'renovacion').eq('estado', 'cerrado').in('poliza_id', trozo);
    const idsT = (cerradas || []).map(t => t.id);
    if (!idsT.length) continue;
    const decididas = new Set();
    for (let j = 0; j < idsT.length; j += TROZO) {
      const { data: hist } = await supabase.from('crm_historial')
        .select('gestion_id').eq('accion', 'cerrar')
        .like('detalle', `${MARCA_NO_RENUEVA}%`).in('gestion_id', idsT.slice(j, j + TROZO));
      (hist || []).forEach(h => decididas.add(h.gestion_id));
    }
    for (const t of cerradas) {
      if (!decididas.has(t.id) || !t.fecha_vencimiento) continue;
      const k = Number(t.poliza_id);
      if (!res.has(k)) res.set(k, new Set());
      res.get(k).add(String(t.fecha_vencimiento).slice(0, 10));
    }
  }
  return res;
}

// ¿Esa póliza tiene la decisión para ESTA vigencia (su vencimiento actual)?
export const decidioNoRenovar = (mapa, polId, fechaVenc) =>
  !!fechaVenc && !!mapa.get(Number(polId))?.has(String(fechaVenc).slice(0, 10));

// Etiqueta legible de un estado de póliza (los valores de la base llevan guion bajo).
export const etiquetaEstadoPoliza = (e) =>
  ({ no_renovada: 'no renovada', en_renovacion: 'en renovación' }[e] || e);
